var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M7.5 14.1665H12.5",
    stroke: "#0062FF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5_2",
    d: "M7.5 10.8335H12.5",
    stroke: "#0062FF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5_3",
    d: "M7.5 7.5H8.33333",
    stroke: "#0062FF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14",
    d: "M4.16669 5C4.16669 3.61929 5.28598 2.5 6.66669 2.5H10.9763C11.4184 2.5 11.8423 2.67559 12.1548 2.98816L15.3452 6.17851C15.6578 6.49107 15.8334 6.915 15.8334 7.35702V15C15.8334 16.3807 14.7141 17.5 13.3334 17.5H6.66669C5.28598 17.5 4.16669 16.3807 4.16669 15V5Z",
    stroke: "#0062FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15",
    d: "M10.8333 2.5V4.16667C10.8333 6.00762 12.3257 7.5 14.1666 7.5H15.8333",
    stroke: "#0062FF",
    strokeWidth: 1.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.dfa6c559d936c576727febde0a68c576.svg";
export { ForwardRef as ReactComponent };